import produce from 'immer'
import { SeccionitsAction, SeccionitsActionTypes } from '../actions/seccionitsActions'
import { ApiStatus, ISeccionitsItem } from '../models'

export const initialSeccionitsState: ISeccionitsState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  seccionits: [],
  foundseccionits: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function seccionitsReducer(state: ISeccionitsState = initialSeccionitsState, action: SeccionitsAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case SeccionitsActionTypes.SEARCH_SECCIONITS:
        draft.searchString = action.searchOptions.searchString
        break
      case SeccionitsActionTypes.SEARCHING_SECCIONITS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case SeccionitsActionTypes.SEARCHING_SECCIONITS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case SeccionitsActionTypes.FOUND_SECCIONITS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep ? draft.foundseccionits.push(...action.payload.seccionits.docs) : (draft.foundseccionits = action.payload.seccionits.docs)
        draft.totalDocs = action.payload.seccionits.totalDocs
        break

      case SeccionitsActionTypes.LOAD_SECCIONITS:
      case SeccionitsActionTypes.LOADING_SECCIONITS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundseccionits = []
        break

      case SeccionitsActionTypes.LOADING_SECCIONITS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case SeccionitsActionTypes.LOADED_SECCIONITS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.seccionits = action.payload.seccionits.docs
        draft.totalDocs = action.payload.seccionits.totalDocs
        break

      case SeccionitsActionTypes.ADD_SECCIONITS:
      case SeccionitsActionTypes.ADDING_SECCIONITS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case SeccionitsActionTypes.ADDING_SECCIONITS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionitsActionTypes.ADDED_SECCIONITS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.seccionits.push(action.payload.seccionits.docs[0])
        if (draft.searchString) draft.foundseccionits.push(action.payload.seccionits.docs[0])
        break

      case SeccionitsActionTypes.REMOVE_SECCIONIT:
        draft.seccionits.splice(
          draft.seccionits.findIndex((seccionit) => seccionit._id === action.payload._id),
          1
        )
        break

      case SeccionitsActionTypes.SOFT_REMOVE_SECCIONITS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionitsActionTypes.SOFT_REMOVED_SECCIONITS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionits.splice(
          draft.seccionits.findIndex((seccionit) => seccionit._id === action.payload._id),
          1
        )
        break

      case SeccionitsActionTypes.SOFT_REMOVING_SECCIONITS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case SeccionitsActionTypes.EDIT_SECCIONITS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case SeccionitsActionTypes.EDITING_SECCIONITS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case SeccionitsActionTypes.EDITED_SECCIONITS:
        draft.addingStatus = ApiStatus.LOADED
        draft.seccionits[draft.seccionits.findIndex((seccionit) => seccionit._id === action.payload._id)] = action.payload
        draft.foundseccionits[draft.foundseccionits.findIndex((seccionit) => seccionit._id === action.payload._id)] = action.payload
        break

      case SeccionitsActionTypes.EDITING_SECCIONITS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ISeccionitsState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  seccionits: ISeccionitsItem[]
  foundseccionits: ISeccionitsItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
